<template>

  <div class="relativecls">

  <div v-if="false" class="validation-rate1">Val:</div>
  <div v-if="false" class="validation-rate2">
      <b-form-select size="sm" v-model="aimodelpara.valid" v-on:change="changeValid" class="modelselect1">
        <option value=0>0%</option>
        <option value=5>5%</option>
        <option value=10>10%</option>
        <option value=15>15%</option>
        <option value=20>20%</option>
        <option value=25>25%</option>
        <option value=30>30%</option>
      </b-form-select>
  </div>
  <b-card border-variant="info" header="AIモデル" class="text-center">

    <div class="smallFont marginbtm">
      Epochs：
      <b-form-select size="sm" v-model="aimodelpara.epochs" v-on:change="changeEpoch" class="modelselect1">
        <option value=10>10</option>
        <option value=20>20</option>
        <option value=30>30</option>
        <option value=50>50</option>
        <option value=100>100</option>
        <option value=300>300</option>
        <option value=500>500</option>
        <option value=1000>1000</option>
        <option value=3000>3000</option>
        <option value=5000>5000</option>
      </b-form-select>
      Optimizer :
      <b-form-select size="sm" v-model="aimodelpara.optim" v-on:change="changeOptim" class="modelselect2">
        <option value='sgd'>sgd</option>
        <option value='momentum'>momentum</option>
        <option value='adagrad'>adagrad</option>
        <option value='adadelta'>adadelta</option>
        <option value='adam'>adam</option>
      </b-form-select>
    </div>
    <!-- Main table element -->
    <table class="table table-striped aimodel-table">
    <tbody>
      <tr v-for="aimodel of aimodels" v-bind:key="aimodel.no">
        <td style="width:80px">中間層{{aimodel.no}}</td>
        <td style="width:80px">{{aimodel.type}}</td>
        <td style="width:80px">{{aimodelVal(aimodel.type, aimodel.val1, aimodel.val2)}}</td>
        <td style="width:80px"><b-button variant="outline-secondary" size="sm" v-if="aimodel.type=='Conv' || aimodel.type=='Dense'" @click="showWeight(aimodel.no)" class="detailbutton">学習状況</b-button>
        <span v-if="aimodel.type!='Conv' && aimodel.type!='Dense'">-</span></td>
        <td style="width:20px"><b-icon icon="trash" font-scale="1.2" @click="delModel(aimodel.no)" class="color-gray"></b-icon></td>
      </tr>
      <!--tr>
        <td>中間層{{(this.aimodels.length + 1)}}</td>
        <td>Flat</td>
        <td>-</td>
        <td><b-button variant="outline-secondary" size="sm" @click="showWeight(99998)" class="detailbutton">詳細</b-button></td>
        <td>-</td>
      </tr-->
      <tr>
        <td>出力層</td>
        <td>Dense</td>
        <td>{{aimodelVal('Dense', inputNum, 'softmax')}}</td>
        <td><b-button variant="outline-secondary" size="sm" @click="showWeight(99999, '', '', '')" class="detailbutton">学習状況</b-button></td>
        <td>-</td>
      </tr>
    </tbody>
    </table>

    <b-button variant="outline-primary" v-if="false" size="sm" class="btnw" @click="dispModelProg()">プログラム表示</b-button>
    <b-button variant="outline-primary" size="sm" class="btnw" @click="dispModalAdd()">中間層追加</b-button>

  </b-card>

  <!-- Add modal -->
  <div class="modal-overlay" v-if="modalAddShow">
    <div class="modal-content">
      <div class="modalpad">
        <h5>中間層追加</h5>
        <br/>
        <table class="table table-striped addTable">
          <tbody>
            <tr>
              <td>追加タイプ</td>
              <td>
                <b-form-select v-model="addSelModel" v-on:change="changeSelectModel">
                  <option value="Conv">畳み込み(Conv)</option>
                  <option value="Dense">全結合(Dense)</option>
                  <option value="Pool">MaxPoolong(Pool)</option>
                  <option value="Drop">除外化(Drop)</option>
                  <option value="Flat">一次元化(Flat)</option>
                </b-form-select>
              </td>
            </tr>
            <tr>
              <td>{{addValName1}}</td>
              <td>
                <b-form-select v-model="addSelVal1">
                  <option v-for="modelVal1Sel of modelVal1Sels" v-bind:key="modelVal1Sel.key" :value="modelVal1Sel.key">{{modelVal1Sel.name}}</option>
                </b-form-select>
              </td>
            </tr>
            <tr>
              <td>{{addValName2}}</td>
              <td>
                <b-form-select v-model="addSelVal2">
                  <option v-for="modelVal2Sel of modelVal2Sels" v-bind:key="modelVal2Sel.key" :value="modelVal2Sel.key">{{modelVal2Sel.name}}</option>
                </b-form-select>
              </td>
            </tr>
          </tbody>
        </table>
        <br/>
        <div>
          <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">Cancel</b-button>
          <b-button variant="outline-primary" size="sm" class="btnw" @click="addAimodel()">追加</b-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Detail modal -->
  <div class="modal-overlay" v-show="modalDetailShow"><!-- weightareaの読み込みに時間がかかるため、v-show -->
    <div id="modal-content-weight">
      <h5>学習状況</h5>
      <div>現在のニューロンの「重み」と「閾値」を確認できます。（学習は重みと閾値を調整すること）</div>
      <div v-show="weightMessage==''">
        <div class="totalweightarea">
          <div v-if="weightType=='Conv'">【重み情報】重み調整数={{weightInput*5*5*unitfilter}},入力Ch数={{weightInput}},Filter(カーネル)サイズ=5*5,Filter数={{unitfilter}}</div>
          <div v-if="weightType=='Dense'">【重み情報】重み調整数={{weightInput*unitfilter}},入力数={{weightInput}},Unit数={{unitfilter}}</div>
          <div id="weightarea"></div><br>
          <div v-if="weightType=='Conv'">【閾値情報】閾値調整数={{unitfilter}}（ニューロン数={{unitfilter}}）</div>
          <div v-if="weightType=='Dense'">【閾値情報】閾値調整数={{unitfilter}}（ニューロン数={{unitfilter}}）</div>
          <div id="threarea"></div>
        </div>
      </div>
      <div v-if="weightMessage!=''"><font color=red><b>{{weightMessage}}</b></font></div>
      <div>
        <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">閉じる</b-button>
      </div>
    </div>
  </div>

  <!-- Program modal -->
  <div class="modal-overlay" v-if="modalProgShow">
    <div class="modal-content">
      <h5>プログラム表示</h5>
      <div>modalProgramContent</div>
      <div>
        <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">閉じる</b-button>
      </div>
    </div>
  </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'setmodel',
  data () {
    return {
      modalProgShow: false,
      modalProgramContent: '',
      modalDetailShow: false,
      modalDetailContent: '',
      modalAddShow: false,
      addSelModel: 'Conv',
      addConvVals: [ { key: '1', name: '1' }, { key: '2', name: '2' }, { key: '4', name: '4' }, { key: '8', name: '8' },
        { key: '16', name: '16' }, { key: '32', name: '32' }, { key: 64, name: '64' }, { key: 128, name: '128' } ],
      addDropVals: [ { key: '0.1', name: '0.1' }, { key: '0.2', name: '0.2' }, { key: '0.25', name: '0.25' }, { key: '0.3', name: '0.3' },
        { key: '0.4', name: '0.4' }, { key: '0.5', name: '0.5' }, { key: '0.75', name: '0.75' }, { key: '0.9', name: '0.9' } ],
      addActVals: [ { key: 'relu', name: 'ReLu' }, { key: 'sigmoid', name: 'Sigmoid' }, { key: 'softmax', name: 'Softmax' }, { key: 'tanh', name: 'Tanh' } ],
      addFlatVals: [ { key: '0', name: '-' } ],
      addValName1: 'Filter数',
      addSelVal1: '8',
      modelVal1Sels: this.addConvVals,
      addValName2: 'Activation',
      addSelVal2: 'relu',
      modelVal2Sels: this.addActVals,
      wights: null,
      thresholds: null,
      unitfilter: 0,
      weightInput: 0,
      weightType: 'Conv',
      weightMessage: ''
    }
  },
  computed: {
    ...mapState([ 'aimodels', 'aimodelpara', 'inputs', 'model' ]),
    inputNum () {
      return this.inputs.length
    }
  },
  methods: {
    aimodelVal (setType, setVal1, setVal2) {
      if (setType === 'Conv') {
        return setVal1 + 'filters/' + setVal2
      } else if (setType === 'Dense') {
        return setVal1 + 'units/' + setVal2
      } else if (setType === 'Drop') {
        return setVal1
      } else {
        return '-'
      }
    },
    delModel (delNum) {
      this.$store.dispatch('delAimodel', delNum)
    },
    addAimodel () {
      this.$store.dispatch('addAimodel', {type: this.addSelModel, val1: this.addSelVal1, val2: this.addSelVal2})
      this.cancelModal()
    },
    dispModelProg () {
      this.modalProgShow = true
    },
    dispModalAdd () {
      this.modalAddShow = true
    },
    cancelModal () {
      this.modalProgShow = false
      this.modalAddShow = false
      this.modalDetailShow = false
    },
    selectType (selNum) {
      alert(selNum)
    },
    changeSelectModel () {
      if (this.addSelModel === 'Conv') {
        this.addValName1 = 'Filter数'
        this.addSelVal1 = '8'
        this.modelVal1Sels = this.addConvVals
        this.addValName2 = 'Activation'
        this.addSelVal2 = 'relu'
        this.modelVal2Sels = this.addActVals
      } else if (this.addSelModel === 'Dense') {
        this.addValName1 = 'Unit数'
        this.addSelVal1 = '4'
        this.modelVal1Sels = this.addConvVals
        this.addValName2 = 'Activation'
        this.addSelVal2 = 'relu'
        this.modelVal2Sels = this.addActVals
      } else if (this.addSelModel === 'Drop') {
        this.addValName1 = '除外化率'
        this.addSelVal1 = '0.25'
        this.modelVal1Sels = this.addDropVals
        this.addValName2 = '-'
        this.addSelVal2 = 0
        this.modelVal2Sels = this.addFlatVals
      } else {
        this.addValName1 = '-'
        this.addSelVal1 = 0
        this.modelVal1Sels = this.addFlatVals
        this.addValName2 = '-'
        this.addSelVal2 = 0
        this.modelVal2Sels = this.addFlatVals
      }
    },
    changeValid (val) {
      this.$store.dispatch('updateAiparam', {epochs: this.aimodelpara.epochs, optim: this.aimodelpara.optim, valid: val})
    },
    changeEpoch (val) {
      this.$store.dispatch('updateAiparam', {epochs: val, optim: this.aimodelpara.optim, valid: this.aimodelpara.valid})
    },
    changeOptim (val) {
      this.$store.dispatch('updateAiparam', {epochs: this.aimodelpara.epochs, optim: val, valid: this.aimodelpara.valid})
    },
    showWeight (modelno) {
      if (this.model !== undefined && this.model !== null && this.model !== '') {
        this.modalDetailShow = true
        // Conv,Denseが何個目かを確認
        var dispModelNum = 0
        var lastLayer = true
        this.unitfilter = 0
        const sortModels = this.aimodels.sort((a, b) => {
          return (a.no < b.no) ? -1 : (a.no > b.no) ? 1 : 0
        })
        for (var key in sortModels) {
          if (sortModels[key].no === modelno) {
            lastLayer = false
            // this.unitfilter = sortModels[key].val1 // input状態を操作すると変わるためModel情報を使う
            this.weightType = sortModels[key].type
            break
          }
          if (sortModels[key].type === 'Conv' || sortModels[key].type === 'Dense') {
            dispModelNum++
          }
        }
        // 最終出力層の場合
        if (lastLayer) {
          // this.unitfilter = this.inputs.length // input状態を操作すると変わるためModel情報を使う
          this.weightType = 'Dense'
        }
        // Weight取得
        dispModelNum = dispModelNum * 2
        // for (let i = 0; i < this.model.getWeights().length; i++) {
        //  console.log(this.model.getWeights()[i].dataSync())
        for (let i = dispModelNum; i < (dispModelNum + 1); i += 2) {
          this.wights = this.model.getWeights()[i].dataSync()
          this.thresholds = this.model.getWeights()[(i + 1)].dataSync()
          this.unitfilter = this.thresholds.length
          if (this.weightType === 'Dense') {
            this.weightInput = this.wights.length / this.unitfilter
          } else {
            this.weightInput = this.wights.length / this.unitfilter / (5 * 5)
          }
        }
        // tableとrowの大きさを計算
        // console.log('Type:' + this.weightType + ':' + this.weightInput + ':' + this.unitfilter)
        for (var weightType = 0; weightType < 2; weightType++) {
          var totallen = 0
          var tablelen = 0
          var rowlen = 0
          var addarea = null
          // 重み
          if (weightType === 0) {
            addarea = document.getElementById('weightarea')
            totallen = this.wights.length
            if (this.weightType === 'Dense') {
              rowlen = this.unitfilter
              tablelen = totallen
            } else {
              rowlen = 5
              tablelen = 5 * 5
            }
          // 閾値
          } else {
            addarea = document.getElementById('threarea')
            totallen = this.thresholds.length
            if (this.weightType === 'Dense') {
              rowlen = 1
              tablelen = totallen
            } else {
              rowlen = 1
              tablelen = totallen
            }
          }
          // 一旦全て削除
          while (addarea.lastChild) {
            addarea.removeChild(addarea.lastChild)
          }
          // table作成
          var rows = []
          var rowNum = -1
          var table = null
          var cell = null
          for (let i = 0; i < totallen; i++) {
            if (i % tablelen === 0) {
              if (i !== 0) {
                addarea.appendChild(table)
              }
              rows = []
              rowNum = -1
              cell = null
              table = document.createElement('table')
              table.style.border = 'solid 1px lightgray'
              table.style.margin = '0 auto'
              table.style.padding = '5 0'
              // table.classList.add('weighttable') // CSSは効かない
              // 列数表示の行
              rows.push(table.insertRow(-1)) // 行の追加
              rowNum++
              for (let j = 0; j < (rowlen + 1); j++) { // 行数セル表示分＋１
                cell = rows[rowNum].insertCell(-1) // セルの追加
                cell.style.border = 'solid 1px lightgray'
                if (j !== 0) {
                  cell.appendChild(document.createTextNode(j))
                }
              }
            }
            if (i % rowlen === 0) {
              // データの追加行
              rows.push(table.insertRow(-1)) // 行の追加
              rowNum++
              // 行数表示
              cell = rows[rowNum].insertCell(-1) // セルの追加
              cell.style.border = 'solid 1px lightgray'
              cell.appendChild(document.createTextNode(rowNum))
            }
            cell = rows[rowNum].insertCell(-1) // セルの追加
            cell.style.border = 'solid 1px lightgray'
            if (weightType === 0) {
              cell.appendChild(document.createTextNode(this.wights[i]))
            } else {
              cell.appendChild(document.createTextNode(this.thresholds[i]))
            }
          }
          addarea.appendChild(table)
        }
      } else {
        this.$store.dispatch('setMessage', 'AIを学習してから「学習状況」を確認下さい。') // メッセージ表示
        // this.weightMessage = 'AIを学習してから「学習状況」を確認下さい。'
      }
    }
  },
  mounted () {
    this.modelVal1Sels = this.addConvVals // Mount時に割り当てないと反映されない
    this.modelVal2Sels = this.addActVals // Mount時に割り当てないと反映されない
  }
}
</script>
<style scoped>
.modalpad {
  padding: 30px;
}
.aimodel-table {
  font-size: 90%;
}
.aimodel-table td {
  padding: 7px 0 7px 0;
}
.addTable td, select, option {
  font-size: 95%;
  text-align: center;
  vertical-align: middle;
}
.detailbutton {
  font-size: 75%;
  width: 50px;
  height: 23px;
  margin: -3px 0 0 0;
  padding: 2px 0px 0px 0px;
}
.container-fluid{
  padding: 0px;
}
.card-body {
  padding: 5px;
}
.modelselect1 {
  width: 70px;
}
.modelselect2 {
  width: 100px;
}
.marginbtm {
  margin: 0 0 5px 0;
}
#modal-content-weight {
  z-index:101;
  width:90% !important;
  padding: 5px;
  border: 0;
  background:#fff;
  border-radius: 10px;
}
.totalweightarea {
  max-height: 80vh;
  max-width: 90vw - 20px;
  overflow: auto;
  margin: 10px;
  padding: 0;
}
#modal-content-weight td {
  padding: 0;
  border: 1px;
  font-size: 70%;
}
.validation-rate1 {
  z-index:9;
  position: absolute;
  top: 30px;
  right: 75px;
  font-size: 70%;
}
.validation-rate2 {
  z-index:9;
  position: absolute;
  top: 12px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/SetModel.vue